import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './views/pages/login/login.component';
import { NgModule } from '@angular/core';
import { Page404Component } from './views/pages/page404/page404.component';
import { Page500Component } from './views/pages/page500/page500.component';
import { PetRegisterComponent } from './views/pages/pet-register/pet-register.component';
import { PickUpBookingComponent } from './views/pages/pick-up-booking/pick-up-booking.component';
import { PublicQRCodeComponent } from './views/pages/public-qr-code/public-qr-code.component';
import { RegisterComponent } from './views/pages/register/register.component';
import { AuthenticationGuard } from './services/authentication.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_dashboard' },
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'pet',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_pet_page' },
        loadChildren: () =>
          import('./views/pet/pet.module').then((m) => m.PetModule)
      },
      {
        path: 'owner',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_owner_page' },
        loadChildren: () =>
          import('./views/owner/owner.module').then((m) => m.OwnerModule)
      },
      {
        path: 'check-in',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_checkin_page' },
        loadChildren: () =>
          import('./views/check-in/check-in.module').then((m) => m.CheckInModule)
      },
      {
        path: 'check-out',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_checkout_page' },
        loadChildren: () =>
          import('./views/check-out/check-out.module').then((m) => m.CheckOutModule)
      },
      {
        path: 'invoice',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_invoice_page' },
        loadChildren: () =>
          import('./views/invoice/invoice.module').then((m) => m.InvoiceModule)
      },
      {
        path: 'pick-up',
        loadChildren: () =>
          import('./views/pick-up/pick-up.module').then((m) => m.PickUpModule)
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./views/user/user.module').then((m) => m.UserModule)
      },
      {
        path: 'theme',
        loadChildren: () =>
          import('./views/theme/theme.module').then((m) => m.ThemeModule)
      },
      {
        path: 'base',
        loadChildren: () =>
          import('./views/base/base.module').then((m) => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () =>
          import('./views/buttons/buttons.module').then((m) => m.ButtonsModule)
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./views/forms/forms.module').then((m) => m.CoreUIFormsModule)
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./views/charts/charts.module').then((m) => m.ChartsModule)
      },
      {
        path: 'icons',
        loadChildren: () =>
          import('./views/icons/icons.module').then((m) => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./views/notifications/notifications.module').then((m) => m.NotificationsModule)
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./views/widgets/widgets.module').then((m) => m.WidgetsModule)
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/pages.module').then((m) => m.PagesModule)
      },
      {
        path: 'reports',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_report_page' },
        loadChildren: () =>
          import('./views/reports/reports.module').then((m) => m.ReportsModule)
      },
      {
        path: 'expense',
        loadChildren: () =>
          import('./views/expense/expense.module').then((m) => m.ExpenseModule)
      },
      {
        path: 'qr-code',
        canActivate: [AuthenticationGuard],
        data: { permission: 'api.view_qrcode_page' },
        loadChildren: () =>
          import('./views/qr-code/qr-code.module').then((m) => m.QRCodeModule)
      },
      {
        path: 'database-backup',
        canActivate: [AuthenticationGuard],
        data: { permission: '' },
        loadChildren: () =>
          import('./views/database-backup/database-backup.module').then((m) => m.DatabaseBackupModule)
      },
    ]
  },
  {
    path: '404',
    component: Page404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: Page500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register-pet',
    component: PetRegisterComponent,
    data: {
      title: 'Register Dog'
    }
  },
  {
    path: 'book-pick-up',
    component: PickUpBookingComponent,
    data: {
      title: 'Register Dog'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    },
  },
  {
    path: 'public-qr-code/:id',
    component: PublicQRCodeComponent,
    data: {
      title: 'QR Code Public'
    }
  },
  {path: '**', redirectTo: 'dashboard'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking'
      // relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
